import * as types from '@/store/mutation-types'

export default {
    namespaced: true,
    state: {
        notifications: []
    },

    actions: {
        fetchAll ({ commit }, { isRead, page, perPage } = {}) {
            return window.coreAxios.get('/driverAssistant/notifications', { params: { isRead, page, perPage } }).then(({ data }) => {
                commit(types.STORE_NOTIFICATION, data.data)
                return data.data
            })
        },

        markAllRead ({ commit }) {
            return window.coreAxios.put('/driverAssistant/notifications/markallread')
        }
    },
    mutations: {
        [types.STORE_NOTIFICATION] (state, notifications) {
            state.notifications = notifications
        }
    }
}
